export class Calendario {
  constructor({
    id = null,
    nome = null,
    anoCalendario = null,
    periodo = "Anual",
    vigente = false,
    ativo = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.anoCalendario = anoCalendario;
    this.periodo = periodo;
    this.vigente = vigente;
    this.ativo = ativo;
  }
  static Build() {
    return new Calendario({
      id: null,
      nome: null,
      anoCalendario: null,
      vigente: false,
      ativo: null,
    });
  }
  format() {
    return this;
  }
}
